"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadData = void 0;
var uploadData_1 = require("./uploadData");
Object.defineProperty(exports, "uploadData", { enumerable: true, get: function () { return uploadData_1.uploadData; } });
